import styles from "./CollapsableBlock.module.css"
import { ReactComponent as ChevronIcon } from "../../assets/images/icons/ic-chevron.svg"
import React, { useEffect, useState } from "react"
import Markdown from "react-markdown"
import rehypeRaw from "rehype-raw"

const CollapsableBlock = React.forwardRef(({id, title = '', children, expanded = false, style, onClick = () => { }, disabled }, ref) => {
    const [exp, setExp] = useState(expanded)

    useEffect(() => {
        setExp(expanded ?? false)
    }, [expanded])

    const toggleExpand = () => {
        setExp(!exp)
    }

    return (
        <div ref={ref} id={id} className={styles.container} 
        style={{
            marginTop: style?.marginTop,
            marginBottom: style?.marginBottom,
            marginLeft: style?.marginLeft,
            marginRight: style?.marginRight,
            borderTop: style?.borderTop,
            borderBottom: style?.borderBottom,
            borderLeft: style?.borderLeft,
            borderRight: style?.borderRight,
            borderTopLeftRadius: style?.borderTopLeftRadius,
            borderTopRightRadius: style?.borderTopRightRadius,
            borderBottomLeftRadius: style?.borderBottomLeftRadius,
            borderBottomRightRadius: style?.borderBottomRightRadius,
            boxShadow: style?.boxShadow,
            display: style?.display,
            visibility: style?.visibility,
            opacity: style?.opacity,
        }} 
        onClick={onClick}>
            <button className={`${styles.header} ${exp ? styles.expanded : ''}`} 
            style={{ 
                paddingTop: style?.paddingTop,
                paddingBottom: style?.paddingBottom,
                paddingLeft: style?.paddingLeft,
                paddingRight: style?.paddingRight,
                fontSize: style?.fontSize,
                fontWeight: style?.fontWeight,
                fontFamily: style?.fontFamily,
                lineHeight: style?.lineHeight,
                backgroundColor: style?.backgroundColor,
                color: style?.color,
                textAlign: style?.textAlign,
                whiteSpace: style?.whiteSpace,
                textDecoration: style?.textDecoration,
                textTransform: style?.textTransform,
            }} 
            onClick={() => {
                if(!disabled){
                    toggleExpand()
                }
            }}>
                <div style={{ flex: 1, width: '100%' }}>
                    <Markdown rehypePlugins={[rehypeRaw]}>{title ?? ''}</Markdown>
                </div>
                <ChevronIcon className={`${styles.chevronIcon} ${exp ? styles.expanded : ''}`}></ChevronIcon>
            </button>
            <div className={`${styles.content} ${exp ? styles.expanded : ''}`}>
                {children}
            </div>
        </div>
    )
});

export default CollapsableBlock